/**
 * Mapbox configuration.
 *
 * The value below is a **public** Mapbox access token (`pk.*`). Public tokens are
 * designed to be embedded in client-side code and are visible in the browser, so
 * shipping it here for the POC is acceptable. Before any public deployment:
 *   - URL-restrict this token in the Mapbox account, and/or
 *   - supply a real token via the `VITE_MAPBOX_TOKEN` env var (which overrides
 *     this default) sourced from SWA app settings / Key Vault.
 */
export const MAPBOX_TOKEN: string =
  (import.meta.env.VITE_MAPBOX_TOKEN as string | undefined) ??
  'pk.eyJ1IjoicmljaGFyZGJ0IiwiYSI6ImNtMWxkdDV3MzA3djgyaXB2OXJjM2hzaHoifQ.SJNYB6CFHCzfqZOKtdiUPg';

/**
 * Theme-matched Mapbox style URLs (Command = dark ops, Field = sunlit).
 * Both chosen to render minor roads and unsealed tracks/trails clearly —
 * `dark-v11` in particular renders little beyond major roads, which matters
 * for rural brigade access planning where the track network is the point.
 */
export const MAPBOX_STYLES = {
  command: 'mapbox://styles/mapbox/navigation-night-v1',
  field: 'mapbox://styles/mapbox/outdoors-v12',
} as const;
